import React, {useEffect, useState} from 'react';
import {Button,Wordmark} from '../../ui/index.js';
import {COPY} from './copy.js';
import {Booking} from './Booking.jsx';
import {Stage,HomeLink} from './Stage.jsx';
import {Actions,StepHeader} from './WebsiteOnboarding.jsx';
import './onboarding.css';

// /randevu?t=… : the link in the visitor's e-mail, for booking later or seeing the booked meeting again.
export function BookingPage(){
 const params=new URLSearchParams(location.search),token=params.get('t')||'';
 const [language,setLanguage]=useState(params.get('lang')==='en'?'en':'tr'),t=COPY[language],[ready,setReady]=useState(false),[booked,setBooked]=useState(false);
 useEffect(()=>{document.documentElement.lang=language;document.title=language==='en'?'Meeting · BiSponsor':'Görüşme · BiSponsor';},[language]);
 return <main className="onboarding" data-step="meeting" data-stage={booked?'booked':'step'}>
  <Stage kind={booked?'booked':'step'} step="meeting" topbar={<header className="onboarding-topbar"><HomeLink language={language}/><span className="onboarding-topbar-end"><Button size="sm" className="onboarding-language" aria-label={t.switchLabel} onClick={()=>setLanguage(language==='tr'?'en':'tr')}>{t.switchTo}</Button></span></header>}/>
  <div className="onboarding-body"><div className="onboarding-panel"><Booking token={token} language={language} t={t} Header={StepHeader} Actions={Actions} onReady={()=>setReady(true)} onBooked={()=>setBooked(true)}/>
   {/* Only a link that opened offers the way back; a broken one already offers sign-in, so nothing flashes while it loads. */}
   {ready&&<p className="onboarding-by"><a href="/panel">{language==='en'?'Back to the platform':'Platforma dön'}</a></p>}</div></div>
 </main>;
}
